__turbopack_context__.v({
  "checkboxGroup": "FormMortgageModal-module-scss-module__npFhpW__checkboxGroup",
  "checkboxRow": "FormMortgageModal-module-scss-module__npFhpW__checkboxRow",
  "checkboxText": "FormMortgageModal-module-scss-module__npFhpW__checkboxText",
  "close": "FormMortgageModal-module-scss-module__npFhpW__close",
  "cta": "FormMortgageModal-module-scss-module__npFhpW__cta",
  "error": "FormMortgageModal-module-scss-module__npFhpW__error",
  "field": "FormMortgageModal-module-scss-module__npFhpW__field",
  "form": "FormMortgageModal-module-scss-module__npFhpW__form",
  "hideForm": "FormMortgageModal-module-scss-module__npFhpW__hideForm",
  "initialPaymentWrapper": "FormMortgageModal-module-scss-module__npFhpW__initialPaymentWrapper",
  "modal": "FormMortgageModal-module-scss-module__npFhpW__modal",
  "modalShow": "FormMortgageModal-module-scss-module__npFhpW__modalShow",
  "overlay": "FormMortgageModal-module-scss-module__npFhpW__overlay",
  "overlayVisible": "FormMortgageModal-module-scss-module__npFhpW__overlayVisible",
  "phone": "FormMortgageModal-module-scss-module__npFhpW__phone",
  "privacyText": "FormMortgageModal-module-scss-module__npFhpW__privacyText",
  "showLoader": "FormMortgageModal-module-scss-module__npFhpW__showLoader",
  "spinner": "FormMortgageModal-module-scss-module__npFhpW__spinner",
  "thankstext": "FormMortgageModal-module-scss-module__npFhpW__thankstext",
  "title": "FormMortgageModal-module-scss-module__npFhpW__title",
});
